import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

const ADDRESS_NUMBER_COOKIE = 'we_an';

function readAddressNumberCookie(): string | null {
	const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + ADDRESS_NUMBER_COOKIE + '=([^;]*)'));
	return match ? decodeURIComponent(match[1]) : null;
}

export const AuthHeadersInterceptor: HttpInterceptorFn = (req, next) => {
	const oauthService = inject(OAuthService);
	const token = oauthService.getAccessToken();

	const headers: Record<string, string> = {};

	if (token) {
		headers['Authorization'] = `Bearer ${token}`;
	}

	const shouldSendAddressNumber =
		req.url.includes('/rest/user-profile-we/') && !req.url.includes('customers/me/address-numbers');

	const selectedAddressNumber = readAddressNumberCookie();

	if (shouldSendAddressNumber && selectedAddressNumber) {
		headers['address-number'] = selectedAddressNumber;
	}

	if (Object.keys(headers).length > 0) {
		req = req.clone({ setHeaders: headers });
	}

	return next(req);
};
